module.exports = __webpack_public_path__ + "baff0e403c45d82e93e94712597d4597.pdf";